
import type { Bike } from "@/api/bikeService";

export interface ComponentBike {
  id: string;
  model: string;
  serialNumber: string;
  status: 'active' | 'inactive';
  batteryLevel: number;
  distanceTraveled: number;
  location: string;
  locationId?: string;
  locationIsHome?: boolean;
  userName?: string;
}

export function mapBikeToComponentBike(bike: any): ComponentBike {
  // Determine location string
  let location = 'Site: Unassigned';
  let locationId = undefined;
  let locationIsHome = false;
  let userName = undefined;
  
  if (bike.site?.name) {
    location = bike.site.name;
    locationId = bike.site_id;
    locationIsHome = false;
  } else if (bike.users?.username) {
    location = `Home: ${bike.users.username}`;
    locationId = bike.user_location_id;
    locationIsHome = true;
    userName = bike.users.username;
  }
  
  return {
    id: bike.id,
    model: bike.model?.name || 'Unknown model',
    serialNumber: bike.serial_number || '',
    status: bike.status || 'inactive',
    batteryLevel: bike.battery_level || 0,
    distanceTraveled: bike.distance_traveled_km || 0,
    location,
    locationId,
    locationIsHome,
    userName
  };
}
